import './HomePage.css';

function HomePage() {
  return (
	<div className="container-home">Home</div>
  );
}


export default HomePage;
